export default {
  flat: {
    title: 'Preço fixo',
    subtitle: 'Preço único sem indicação de quantidade',
  },
  per_unit: {
    title: 'Fixo por quantidade',
    subtitle: 'Preço único multiplicado pela quantidade vendida',
  },
  volume_usage: {
    title: 'Fixo por faixa',
    subtitle: 'Desconto ou acréscimo de preço por faixa',
    start: 'Entre',
    end: 'E',
    factor: 'cobrar',
  },
  step_usage: {
    title: 'Faixa variável',
    subtitle: 'Desconto ou acréscimo de preço por quantidade',
    start: 'De',
    end: 'Até',
    factor: 'multiplicar por',
  },
  tier_usage: {
    title: 'Faixa acumulada',
    subtitle: 'Preço acumulado pelas faixas de utilização',
    start: 'De',
    end: 'Até',
    factor: 'multiplicar por',
  },
};
